import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { zodOptionalDateRange, zodOptionalIdArray } from 'routes/routeUtils';
import { z } from 'zod';

const labClaimsDashboardStatusSchema = z.enum(['transmitted', 'pending', 'closed_by_lab']);

export const labClaimsDashboardRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/claims/dashboard',
  validateSearch: z.object({
    status: z.tuple([labClaimsDashboardStatusSchema], labClaimsDashboardStatusSchema).optional(),
    pharmacyIds: zodOptionalIdArray,
    groupIds: zodOptionalIdArray,
    salesRepIds: zodOptionalIdArray,
    regionalDirectorIds: zodOptionalIdArray,
    createdAtRange: zodOptionalDateRange,
  }),
}).lazy(() =>
  import('pages/lab/Claims/LabClaimsDashboardPage/LabClaimsDashboardPage').then((d) => d.Route)
);
